import { Loading } from 'pages/loading/ui/loading.page';
import React from 'react';
import { useParams } from 'react-router-dom';
import { PageLayout } from 'shared/ui';
import { CreatePointForm, Header } from 'widgets';
import { OnboardingStepIndicator } from 'features/onboarding';

export const CreatePointPage: React.FC = () => {
  const { id } = useParams();

  return id ? (
    <>
      <OnboardingStepIndicator />
      <PageLayout>
        <Header />
        <CreatePointForm businessId={id} />
      </PageLayout>
    </>
  ) : (
    <Loading />
  );
};
